import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getSalesOfficeBasedMarketsService = async (salesOfficeId) => {
   const response = getData(`market/getBySalesOffice/?salesOfficeId=${salesOfficeId}`);
    return response;
};

export const getMarketsService = async () => {
   const response = getData("market/get");
    return response;
};

export const getExpirationDateService = async () => {
    const response = getData("/dummyJSON/customerExpiration.json");
    return response;
 };
 export const getStatusService = async () => {
    const response = getData("/dummyJSON/customerStatus.json");
    return response;
 };

export const getRenderCustomerService = async (salesOfficeId) => {
   const response = getData(`customer/getBySalesOffice/?salesOfficeId=${salesOfficeId}`);
   return response;
};

export const getCompanyTypeService = async () => {
   const response = getData("companyType/get");
    return response;
};

export const createNewCustomerService = async (payload) => {
   const response = await putData("customer/createWithContact",payload);
    return response;
};

export const updateCustomerService = async (payload) => {
   return await postData(`customer/update?customerId=${payload.customerId }`, payload);
};

export const deleteCustomerService = async (payload) => {
   return await deleteData(`customer/delete?customerId=${payload.customerId}`);
};

export const getLicenseByCustomerService = async (customerId) => {
   const response = getData(`license/getByCustomer/?customerId=${customerId}`);
    return response;
};

export const getTransactionByCustomerService = async (customerId) => {
   const response = getData(`transaction/getByCustomer/?customerId=${customerId}`);
    return response;
};

/*export const getToolsService = async () => {
   const response = await getData("/tool/get");
   return response;
 };*/

export const getTransactionTypeService = async () => {
   const response = await getData("/transactionType/get");
   return response;
 };

 export const getDiscountsService = async () => {
   const response = await getData("/discount/get");
   return response;
 };
 export const generateNewLicenseService = async (payload) => {
   const response = await putData("license/generateLicense",payload);
    return response;
};
export const createNewLicenseService = async (payload) => {
   const response = await putData("license/create",payload);
    return response;
};

export const renewalLicenseService = async (payload) => {
   //return await postData(`license/update?licenseId=${payload.licenseId }`, payload);
   return await postData(`license/renewLicense`, payload);
};

export const convertLicenseService = async (payload) => {
  //return await postData(`license/update?licenseId=${payload.licenseId }`, payload);
  return await postData(`license/convertTrial`, payload);
};
 
export const updateQuantityService = async (payload,params) => {
   return await postData(`license/updateQuantity?licenseId=${params.licenseId}&newQuantity=${params.newQuantity}`, payload);    
};

export const getContactsByCustomerService = async (customerId) => {
   const response = getData(`customerContact/getByCustomerId/?customerId=${customerId}`);
    return response;
};

export const createNewContactService = async (payload) => {
   const response = await putData("customerContact/create",payload);
    return response;
};

export const deleteCustomerContactService = async (payload) => {
   return await deleteData(`customerContact/delete?customerContactId=${payload.customerContactId}`);
};

export const updateCustomerContactService = async (payload) => {
   return await postData(`customerContact/update?customerContactId=${payload.customerContactId }`, payload);
};

export const getEmailSendToDetails = async(payload) => {
   return await getData(`email/getEmailMailContent?licenseId=${payload.licenseId}&userId=${payload.userId}`)
}
// Email api update by Kevin (07-Feb-2025)
export const getEmailSendToUser = async(payload) => {
   return await postData(`email/sendEmail?licenseId=${payload.licenseId}&userEmail=${localStorage.getItem("userEmailAddress")}`)
}
// Send email popup change(05-March-2025)
export const getEmailContents = async(payload) => {
   return await getData(`email/getEmailMailContent?licenseId=${payload.licenseId}&userEmail=${localStorage.getItem("userEmailAddress")}`)
}